export const studentsListTitle = [
  {
    titleName: "id",
    colWidth: "30px",
  },
  {
    titleName: "regno",
    colWidth: "100px",
  },
  {
    titleName: "name",
    colWidth: "150px",
  },
  {
    titleName: "class",
    colWidth: "60px",
  },
  {
    titleName: "gender",
    colWidth: "80px",
  },
  {
    titleName: "DOB",
    colWidth: "95px",
  },
  {
    titleName: `${"father's name"}`,
    colWidth: "150px",
    key: "fathersName",
  },
  {
    titleName: `${"mother's name"}`,
    colWidth: "150px",
    key: "mothersName",
  },
];
